<template>
  <div class="searchHotel">
    <div class="search"
         v-if='!isSimpleMode'>
      <div class="mint-searchbar">
        <div class="mint-searchbar-inner">
          <i class="mintui mintui-search"></i>
          <input type="search"
                 :placeholder="$t('search_placeholder')"
                 class="mint-searchbar-core"
                 v-model="value"
                 @input='inputSearch'>
        </div>
        <a class="mint-searchbar-cancel"
           v-if="value"
           @click="value='';searchData()">{{ $t('cancel') }}
        </a>
      </div>

      <!--      榮盛集團特殊要求 https://www.tapd.cn/21113861/prong/stories/view/1121113861001098383-->
      <ul class="content clearfix" v-if="dataDisplayW">
        <li class="option"
            @click="settype(-1)"
            :class="{act:type==-1}">{{ $t('search_all') }}
        </li>
        <li class="option"
            @click="settype(100)"
            v-if="showArea"
            :class="{act:type==100}">{{ $t('search_area') }}
        </li>
        <li class="option"
            @click="settype(30)"
            v-if="showBrand"
            :class="{act:type==30}">{{ $t('search_brand') }}
        </li>

        <li class="option"
            @click="settype(200)"
            :class="{act:type==200}">{{ $t('search_hotel') }}
        </li>
        <li class="option"
            @click="settype(20)"
            v-if="showCity"
            :class="{act:type==20}">{{ $t('search_city') }}
        </li>
      </ul>

      <ul class="content clearfix" v-else>
<!--        <li class="option"-->
<!--            @click="settype(900)"-->
<!--            :class="{act:type==900}">{{ $t('search_often') }}-->
<!--        </li>-->
        <li class="option"
            @click="settype(-1)"
            :class="{act:type==-1}">{{ $t('search_all') }}
        </li>
        <li class="option"
            @click="settype(200)"
            :class="{act:type==200}">{{ $t('search_hotel') }}
        </li>
        <li class="option"
            @click="settype(20)"
            v-if="showCity"
            :class="{act:type==20}">{{ $t('search_city') }}
        </li>
        <li class="option"
            @click="settype(30)"
            v-if="showBrand"
            :class="{act:type==30}">{{ $t('search_brand') }}
        </li>
        <li class="option"
            @click="settype(100)"
            v-if="showArea"
            :class="{act:type==100}">{{ $t('search_area') }}
        </li>
      </ul>
    </div>
    <div class="scrolld"
         :class='{isSimpleMode: isSimpleMode}'>
      <template v-for="(item,index) in disData">
        <a class="mint-cell"
           :key='"top-main-test" + index'
           @click='selectHotel(item)'
           v-if="type == 100 || (type == 30 && !isLcg)">
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title">
               <span class="mint-cell-text">
                 <span v-if="item.level == 100 || (item.level == 30 && !isLcg)">
                    <i class="iconfont icon-jiahao"
                       v-if="!item.expand"
                       @click="setExpand(item,$event)"></i>
                    <i class="iconfont icon-iconless"
                       v-else
                       @click="setExpand(item,$event)"></i>
                   {{item.descript}}
                 </span>
                 <span v-else
                       class="bk">{{item.index}}、 {{item.descript}}</span>
                </span>
            </div>
            <searchHotelRightPart :isMultSelect='isMultSelect'
                                  :item='item'></searchHotelRightPart>
          </div>
        </a>

<!--        Lcg的二级品牌-->
        <template v-if='type == 30 && ((item.level == 30 || item.level == 200) && isLcg)'>
          <a class="mint-cell"
             :key='"lcg" + index'
             @click='selectHotel(item)'>
            <div class="mint-cell-wrapper">
              <div class="mint-cell-title">
                  <span class="mint-cell-text">
                   <span v-if="item.level == 30 && !item.isSecondBrand">
                      <i class="iconfont icon-jiahao"
                         v-if="!item.expand"
                         @click="setExpand(item,$event)"></i>
                      <i class="iconfont icon-iconless"
                         v-else
                         @click="setExpand(item,$event)"></i>
                     {{ item.descript }}
<!--                     {{item.code}}-->
                   </span>
                   <span v-else
                         class="indent-sm">
                     <span v-if="item.level == 30 && item.isSecondBrand">
                        <i class="iconfont icon-jiahao"
                           v-if="!item.expand"
                           @click="setExpand(item,$event)"></i>
                        <i class="iconfont icon-iconless"
                           v-else
                           @click="setExpand(item,$event)"></i>
                       {{ item.descript }}
<!--                       {{item.code}}-->
                      </span>
                     <span v-else
                           class="indent-sm2">
                       {{ item.index }}、 {{ item.descript }}
                     </span>
                    </span>
                  </span>
              </div>
              <searchHotelRightPart :isMultSelect='isMultSelect'
                                    :item='item'></searchHotelRightPart>
            </div>
          </a>
        </template>

        <!--type == 20 城市，如果能确定一定有省份，可以不需要判断 hasProvince，暂时先留着吧保底-->
        <template v-else-if="type == 20">
          <template v-if='hasProvince'>
            <a class="mint-cell"
               :key='index'
               @click='selectHotel(item)'>
              <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
                  <span class="mint-cell-text">
                   <span v-if="item.level == 15">
                      <i class="iconfont icon-jiahao"
                         v-if="!item.expand"
                         @click="setExpand(item,$event)"></i>
                      <i class="iconfont icon-iconless"
                         v-else
                         @click="setExpand(item,$event)"></i>
                     {{ item.descript }}
                   </span>
                   <span v-else
                         class="indent-sm">
                     <span v-if="item.level == 20">
                        <i class="iconfont icon-jiahao"
                           v-if="!item.expand"
                           @click="setExpand(item,$event)"></i>
                        <i class="iconfont icon-iconless"
                           v-else
                           @click="setExpand(item,$event)"></i>
                       {{ item.descript }}
                      </span>

                     <span v-else
                           class="indent-sm2">
                       {{ item.index }}、 {{ item.descript }}
                     </span>
                    </span>
                  </span>
                </div>
                <searchHotelRightPart :isMultSelect='isMultSelect'
                                      :item='item'></searchHotelRightPart>

              </div>
            </a>
          </template>

          <template v-else>
            <a class="mint-cell"
               :key='index'
               @click='selectHotel(item)'>
              <div class="mint-cell-wrapper">
                <div class="mint-cell-title">
               <span class="mint-cell-text">
                 <span v-if="item.level == 100 || item.level == 20 || item.level == 30">
                    <i class="iconfont icon-jiahao"
                       v-if="!item.expand"
                       @click="setExpand(item,$event)"></i>
                    <i class="iconfont icon-iconless"
                       v-else
                       @click="setExpand(item,$event)"></i>
                   {{ item.descript }}
                 </span>
                 <span v-else
                       class="bk">{{ item.index }}、 {{ item.descript }}</span>
                </span>
                </div>
                <searchHotelRightPart :isMultSelect='isMultSelect'
                                      :item='item'></searchHotelRightPart>

              </div>
            </a>
          </template>
        </template>

        <!-- type == 200 酒店 或者 -1 全部 -->
        <a class="mint-cell"
           :key='index'
           @click='selectHotel(item)'
           v-if="type== 200 || type == -1">
          <div class="mint-cell-wrapper">
            <div class="mint-cell-title">
                <span class="mint-cell-text">
                {{ index + 1 }}、{{ item.descript }}
                  <span class="opera-icon" v-if="item.opera">
                    opera
                  </span>
                  <span class="ischeng-icon" v-if="item.isLiCheng == 'true'">
                    丽呈
                  </span>
                </span>
            </div>
            <searchHotelRightPart :isMultSelect='isMultSelect'
                                  :item='item'></searchHotelRightPart>
          </div>
        </a>
      </template>
      <nothing :condition="disData != null && disData.length == 0"></nothing>
    </div>

    <div class="toggleBtn"
         @click='toggleShowMode'>
      <span v-if='isSimpleMode'>复杂模式</span>
      <span v-else>简单模式</span>
    </div>
  </div>
</template>

<script>
import nothing from "../common/nothing";
import searchHotelRightPart from './searchHotelRightPart'
import _ from 'underscore'

export default {
  data() {
    var dataDisplayW = localStorage.getItem('dataDisplayW') == 'yes'
    var isLcg = (localStorage.getItem('isLcg') == 'yes')

    return {
      dataDisplayW: dataDisplayW,
      isLcg: isLcg,
      hsSearch: localStorage.hsSearchN ?
        JSON.parse(localStorage.hsSearchN) :
        [],
      searchText: "",
      value: "",
      type: -1,
      debounceTask: undefined,
      result: [],
      disData: null,

      hasProvince: false,
      selectedCodes: [],
      expandCodes: [],

      isSimpleMode: false,

      // 特殊需求，需要开启
      showCity: true,
      showBrand: true,
      showArea: true,

      brandList: [],
    };
  },

  props: {
    isMultSelect: {
      type: Boolean,
      default: false
    },
    multChoicedArr: {
      type: Array,
      default() {
        return []
      }
    },
    allowSelectOpera: {
      type: Boolean,
      default: false
    },
    from:{
      type: String,
      default() {
        return ''
      }
    }
  },

  watch: {
    isMultSelect() {
      this.selectedCodes = []
      if(this.isLcg && this.type == 30){
        this.formatLcgBrand()
      } else {
        this.fData()
      }
    }
  },

  mounted() {
    this.type = -1;
    if(this.isLcg){
      this.searchBrand() // /mobilepmsapi/sys/searchBrand
    }
    this.searchData(true);
  },
  methods: {
    setLocalShowMode() {
      this.isSimpleMode = localStorage.getItem('isSimpleMode') == 'simple'
    },
    toggleShowMode() {
      this.isSimpleMode = !this.isSimpleMode
      let temp = this.isSimpleMode ? 'simple' : 'complex'
      localStorage.setItem('isSimpleMode', temp)
      this.fData()
    },
    searchBrand(){
      this.$http
        .post("/mobilepmsapi/sys/searchBrand",{})
        .then(res => {
          this.brandList = res.data.retVal;
        });
    },
    searchData(bfirst) {
      if (!bfirst) {
        this.type = -1;
      }
      this.$http
        .post("/mobilepmsapi/sys/searchHotel", {
          q: this.value,
          maxCount: 15
        })
        .then(res => {
          this.result = res.data.retVal;
          if (this.result.length < 11) { // 如果是10个以内，默认就用简单模式
            this.isSimpleMode = true
          }
          this.setLocalShowMode()
          if(this.isLcg){
            this.hasProvince = false
          } else {
            this.hasProvince = this.ifHasProvice()
          }
          console.log(this.hasProvince)
          this.fData();

          // TODO
          if (localStorage.getItem('hotelSelectType') == 'yes') {
            this.hideTabbarItem()
          }
          //获取集团酒店信息
          if(!localStorage.getItem('currentMiHotel')){
            this.result.map(item=>{
              if(item.code == localStorage.getItem('hotelCode')){
                localStorage.setItem('currentMiHotel',JSON.stringify(item))
              }
            })
          }
        });
    },
    hideTabbarItem() {
      var result = this.result || []
      var showCity = false // 20
      var showBrand = false // 30
      var showArea = false // 100
      result.map((item) => {
        if (item.level == 20) {
          showCity = true
        }
        if (item.level == 30) {
          showBrand = true
        }
        if (item.level == 100) {
          showArea = true
        }
      })
      this.showCity = showCity
      this.showBrand = showBrand
      this.showArea = showArea
    },
    setExpand(item, e) {
      e.stopPropagation();
      this.setExpandCodes(item.code)
      if(this.isLcg && item.level == 30 && this.type == 30){
        this.formatLcgBrand()
      } else {
        this.fData();
      }
    },
    settype(t) {
      if(this.isLcg && t == 30){ // lcg集团需求，二级品牌
        this.type = t;
        this.formatLcgBrand()
      } else {
        if (this.type != t) {
          this.type = t;
          this.fData();
        }
      }
    },

    formatLcgBrand(){
      var ret = []
      var topBrandList = []
      this.brandList.map((item) => {
        if(item.parentBrand){
          topBrandList.push(item.parentBrand)
        }
      })
      var temp = _.union(topBrandList)
      this.brandList.map((item) => {
        if(temp.indexOf(item.code) > -1){
          ret.push(item)
        }
        item.expand = this.expandCodes.indexOf(item.code) > -1
        var tempArr = []
        if(item.expand){
          tempArr = this.getSecondBrand(item.code)
          ret = ret.concat(tempArr)
        }

        if (tempArr.length > 0) { // 加入酒店
          tempArr.map((item2, index2) => {
            if (item2.expand) {
              let arr = this.getItemByType(item2.code, 'brand')
              let index3 = null
              ret.map((item4, index4) => {
                if (item4.code == item2.code) {
                  index3 = index4
                }
              })
              ret.splice(index3 + 1, 0, ...arr)
            }
          })
        }
      })
      this.disData = ret;
    },

    getSecondBrand(code, key){
      var self =this
      let temp = []
      var num = 1;
      this.result.map((item, index) => {
        if (code == item.parentBrand && item.level == 30) { // 需要是城市
          item.index = num++
          item.levelDescript = '二级品牌'
          item.isSecondBrand = true
          item.expand = self.expandCodes.indexOf(item.code) > -1
          temp.push(item);
        }
      })
      return temp
    },

    fData() {
      if (this.isSimpleMode) {
        this.type = -1
      }
      if (this.type == 900) {
        this.formatLocal()
      } else if (this.type == -1) {
        this.formatAll()
      } else if (this.type == 20) {
        if (this.hasProvince) {
          this.formatByProvince()
        } else {
          this.formatType()
        }
      } else {
        this.formatType()
      }
      if (this.isMultSelect) {
        this.setActiveCode()
      }
    },

    // 常用
    formatLocal() {
      var fitem = this.result.length > 0 ? this.result[0] : null;
      var ret = [];
      for (var i = 0; i < this.hsSearch.length; i++) {
        if (fitem == null || fitem.code != this.hsSearch[i].code) {
          ret.push(this.hsSearch[i]);
        }
      }
      if (fitem != null) {
        ret.splice(0, 0, fitem);
      }
      this.disData = ret;
    },

    // 全部
    formatAll() {
      // 荣盛特殊排序要求  集团、区域、品牌、酒店、省份、城市
      if(this.dataDisplayW){
        var temp = []
        var list = this.result || []
        var group = list.filter(item => {return item.level == 0})
        var area = list.filter(item => {return item.level == 100})
        var brand = list.filter(item => {return item.level == 30})
        var hotel = list.filter(item => {return item.level == 200})
        var privince = list.filter(item => {return item.level == 15})
        var city = list.filter(item => {return item.level == 20})
        var final = [...group, ...area, ...brand, ...hotel, ...privince, ...city]
        this.disData = final
      } else {
        if(this.isLcg){
          this.disData = this.insertFirstBrand();
        } else {
          this.disData = this.result;
        }
      }
    },

    insertFirstBrand(){
      var temp = JSON.parse(JSON.stringify(this.result))
      temp.map((item) => {
        if(item.parentBrand){
          item.levelDescript = '二级品牌'
        }
      })

      var firstArr = []
      this.brandList.map((item) => {
        if(!item.parentBrand){
          firstArr.push(item)
        }
      })
      temp.splice(1, 0, ...firstArr)
      return temp
    },

    formatType() {
      var ret = [];
      for (var i = 0; i < this.result.length; i++) {
        var item = this.result[i];
        item.expand = (this.expandCodes.indexOf(item.code) > -1) && (item.level == this.type)
        if (item.level == this.type) {
          ret.push(item);
        }
        if (item.expand) {
          if (this.type == 100) {
            ret = ret.concat(this.getItemByType(item.code, 'area'))
          }
          if (this.type == 20) {
            ret = ret.concat(this.getItemByType(item.code, 'city'))
          }
          if (this.type == 30) {
            ret = ret.concat(this.getItemByType(item.code, 'brand'))
          }
        }
      }
      this.disData = ret;
    },

    ifHasProvice() {
      let result = this.result || [];
      let temp = 0
      if (result.length > 0) {
        result.map((item, index) => {
          if (item.level == 15) { // 满足省份
            temp += 1
          }
        })
      }
      return temp > 0
    },

    // 此时 type 一定是 20了
    formatByProvince() {
      var ret = [];
      for (var i = 0; i < this.result.length; i++) {
        var item = this.result[i];
        let cityList = []
        if (item.level == 15) { // 等于省
          ret.push(item);
        }
        item.expand = this.expandCodes.indexOf(item.code) > -1
        if (item.expand) { // 加入城市
          cityList = this.getCityByProvince(item.code, 'province')
          ret = ret.concat(cityList)
        }
        if (cityList.length > 0) { // 加入酒店
          cityList.map((item2, index2) => {
            if (item2.expand) {
              let arr = this.getItemByType(item2.code, 'city')
              let index3 = null
              ret.map((item4, index4) => {
                if (item4.code == item2.code) {
                  index3 = index4
                }
              })
              ret.splice(index3 + 1, 0, ...arr)
            }
          })
        }
      }
      this.disData = ret;
    },

    getCityByProvince(code, key) {
      let temp = []
      var num = 1;
      this.result.map((item, index) => {
        if (code == item[key] && item.level == 20) { // 需要是城市
          item.index = num++
          temp.push(item);
        }
      })
      return temp
    },

    getItemByType(code, key) {
      let temp = []
      var num = 1;
      this.result.map((item, index) => {
        if (code == item[key]) {
          item.index = num++
          temp.push(item);
        }
      })
      return temp
    },

    inputSearch() {
      if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
      this.debounceTask = setTimeout(() => {
        this.searchData(false);
      }, 1000);
    },

    selectHotel(item) {
      if (this.isMultSelect) {
        this.selectMultHotel(item)
      } else {
        if(this.isLcg && item.level == 30 && !item.parentBrand){
          var tempItem = JSON.parse(JSON.stringify(item))
          tempItem.code = this.findSecondCodes(tempItem)
          if(this.from == 'pageHeader'){
            this.$emit("setHotelLcg", tempItem);
          } else {
            this.$emit("selectHotel", tempItem);
          }
        } else {
          this.selectSingleHotel(item)
        }
      }
    },

    findSecondCodes(firstBrand){
      var arr = []
      this.result.map((item) => {
        if(item.parentBrand == firstBrand.code){
          arr.push(item.code)
        }
      })
      return arr.join(',')
    },

    selectMultHotel(item) {
      if (item.level == 200) {
        if (item.opera) {
          this.msg2(this.$t('searchHotel_opera_notice'))
        } else {
          this.$set(item, "selected", !item.selected);
          this.setSelfCode(item.code)
          this.$emit('selectMultItem', item)
          this.fData()
        }
      } else {
        this.msg2(this.$t('contrll_only_hotel'))
      }
    },
    setSelfCode(code) {
      let index = this.selectedCodes.indexOf(code)
      if (index > -1) {
        this.selectedCodes.splice(index, 1)
      } else {
        this.selectedCodes.push(code)
      }
    },

    setExpandCodes(code) {
      let index = this.expandCodes.indexOf(code)
      if (index > -1) {
        this.expandCodes.splice(index, 1)
      } else {
        this.expandCodes.push(code)
      }
    },

    setActiveCode() {
      let expandCodes = this.expandCodes || []
      this.disData.map((item, index) => {
        item.selected = false
        if (expandCodes.indexOf(item.code) > -1) {
          item.expand = true
        }
      })
      let temp = JSON.parse(JSON.stringify(this.disData))
      this.disData = []
      if (this.isMultSelect) {
        let codes = this.selectedCodes || []
        if (codes.length > 0 && temp.length > 0) {
          temp.map((item2, index2) => {
            if (codes.indexOf(item2.code) > -1) {
              item2.selected = true
            }
          })
        }
      }
      this.disData = temp
    },

    selectSingleHotel(item) {
      if (this.allowSelectOpera) {
        this.singleNext(item)
      } else {
        if (item.opera) {
          this.msg2(this.$t('searchHotel_opera_notice2'))
        } else {
          this.singleNext(item)
        }
      }
    },

    singleNext(item) {
      this.finditem(item);
      if (this.hsSearch.length >= 9) {
        this.hsSearch.pop();
      }
      this.hsSearch.splice(0, 0, item);
      localStorage.setItem("hsSearchN", JSON.stringify(this.hsSearch));

      this.$userLocal.clearUserLocal()

      this.setHotel(item);
    },

    finditem(item) {
      for (var i = 0; i < this.hsSearch.length; i++) {
        if (this.hsSearch[i].code == item.code) {
          this.hsSearch.splice(i, 1,);
          return true;
        }
      }
      return false;
    },
    setHotel(item) {
      this.$emit("selectHotel", item);
    }
  },
  components: {
    nothing, searchHotelRightPart
  }
};
</script>

<style lang="less">
.searchHotel {

  .opera-icon {
    display: inline-block;
    background: orange;
    color: #fff;
    padding: 3px 5px;
    margin-left: 5px;
    border-radius: 3px;
  }
  .ischeng-icon {
    display: inline-block;
    background: #2ab127;
    color: #fff;
    padding: 3px 5px;
    margin-left: 5px;
    border-radius: 3px;
  }

  .toggleBtn {
    position: fixed;
    bottom: 80px;
    right: 0px;
    width: 30px;
    height: 80px;
    background: #ffa756;
    color: #fff;
    text-align: center;
    z-index: 10;
    border-radius: 8px 0 0 8px;
    align-items: center;
    display: flex;
    justify-content: space-around;

    > span {
      display: inline-block;
      line-height: 16px;
      width: 20px;
    }

    &:active {
      background: darken(#ff8000, 5%)
    }

    .iconfont {
      line-height: 45px;
      font-size: 20px;
    }
  }

  .search {
    position: fixed;
    top: 1.06rem;
    z-index: 1;
    width: 100%;
  }

  .mint-searchbar {
    background: #ffffff;
    border-radius: 5px;
  }

  .mint-searchbar-inner {
    background: #f7f8fa;
    border-radius: 1rem;
  }

  .mint-searchbar-core {
    text-indent: 0.3rem;
    background: #f7f8fa;
  }

  .mintui-search {
    font-size: 0.5rem;
    margin-left: 0.2rem;
  }

  .mint-searchbar-cancel {
    color: #000;
  }

  .mint-cell {
    &:active {
      background: #eaeaea;
    }
  }

  .mint-cell-wrapper {
    font-size: 0.35rem;
    border-bottom: 1px solid #ccc;
    width: 86%;
    margin: 0 auto;

    .bk {

      padding-left: 0.8rem;
    }

    .indent-sm {
      padding-left: 0.4rem;
    }

    .indent-sm2 {
      padding-left: 0.8rem;
    }
  }

  .mint-cell-text {
    .iconfont {
      color: #999;
      padding: 0.2rem;
    }
  }

  .isEmpty {
    margin-top: 1.5rem;
  }

  .history {
    margin-top: 44px !important;
    padding: 3px 0 9px 0;
    background-color: #f6f8f9;

    .his_top_wrapper {
      background: #ffffff;
      width: 100%;
    }

    .his_top {
      background: #ffffff;
      width: 90%;
      height: 39px;
      box-sizing: border-box;
      margin: 10px auto 0 auto;
      line-height: 39px;
      border-bottom: 1px solid #ddd;

      .his_left {
        float: left;
        font-size: 12px;
        color: #666666;
      }

      .his_right {
        float: right;

        .iconfont {
          font-size: 16px;
        }
      }
    }
  }

  .recommend {
    margin-top: 5px;
    background-color: #fff;

    .rec_top {
      background: #ffffff;
      width: 345px;
      height: 39px;
      box-sizing: border-box;
      margin: 0 auto;
      line-height: 39px;
      border-bottom: 1px solid #ddd;

      .rec_left {
        float: left;
        font-size: 12px;
        color: #666666;
      }

      .rec_right {
        float: right;

        .iconfont {
          font-size: 16px;
        }
      }
    }
  }

  .mint-cell:last-child {
    background-image: none;
  }

  .mint-search-list {
    -webkit-overflow-scrolling: touch;
  }

  .mint-search-list-warp .mint-cell:nth-of-type(1) .mint-cell-wrapper {
    background-image: none;
  }

  .mint-cell-wrapper {
    border-bottom: none;
  }

  .scrolld {
    overflow-y: scroll;
    height: ~"calc(100vh - 4.1rem)";
    position: absolute;
    width: 100%;
    margin-top: 2.55rem;
    -webkit-overflow-scrolling: touch;

    &.isSimpleMode {
      margin-top: 0;
      height: ~"calc(100vh - 1.1rem)";
    }
  }

  .content {
    background: #f7f8fa;
    width: 96%;
    margin: 0 auto;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .option {
      flex: 1;
      text-align: center;
      height: 1rem;
      line-height: 1rem;
      color: #333333;
      font-size: 14px;

      &.act {
        border-bottom: 2px #f69c2d solid;
        color: #f69c2d
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// searchHotel.vue?50af2c36